import { LocalesType } from '@modules/lang-module/types/locales.type'
import { EnvironmentInjector, inject, OnDestroy, OnInit, runInInjectionContext } from '@angular/core'
import { LanguageService } from '@modules/lang-module/services/language.service'
import { LocalesInterface } from '@modules/lang-module/interfaces/locales.interface'
import { appInjector } from '../../../app.config'
import { UtilsService } from '@shared/services/utils.service'

export function UseLocales(locales: LocalesType): ClassDecorator {
	return (constructor: Function): void => {
		const prototypeOnInit: OnInit = constructor.prototype
		const originalNgOnInit: Function = prototypeOnInit.ngOnInit
		const prototypeOnDestroy: OnDestroy = constructor.prototype
		const originalOnDestroy: Function = prototypeOnDestroy.ngOnDestroy

		let key: string = '0'

		prototypeOnInit.ngOnInit = function (): void {
			const injector: EnvironmentInjector | null = appInjector
			if (!injector) return

			runInInjectionContext(injector, (): void => {
				const utilsService: UtilsService = inject<UtilsService>(UtilsService)

				key = utilsService.generateUniqId()

				const locale: LocalesInterface = { key, locales }

				const languageService: LanguageService = inject<LanguageService>(LanguageService)

				languageService.useLocale(locale)
			})

			if (typeof originalNgOnInit === 'function') originalNgOnInit.apply(this)
		}

		prototypeOnDestroy.ngOnDestroy = function (): void {
			const injector: EnvironmentInjector | null = appInjector
			if (!injector) return

			runInInjectionContext(injector, (): void => {
				const languageService: LanguageService = inject<LanguageService>(LanguageService)

				languageService.deleteLocale(key)
			})

			if (typeof originalOnDestroy === 'function') originalOnDestroy.apply(this)
		}
	}
}
